// extracted by css-extract-rspack-plugin
export default {"buttonWrapper":"buttonWrapper-XhoD3r","searchSection":"searchSection-dUSMZD"};